import { decodeBase64UrlJson } from "./url";

/** The ID-token claims consulted for session detection. */
type IDToken = {
  /** The account's primary e-mail address. */
  email?: string;
  /** Expiry in seconds since epoch. */
  exp?: number;
};

/**
 * The agreed localStorage keys under which clients persist the ID token on
 * this origin, one per build flavour.
 */
const ID_TOKEN_STORAGE_KEYS = ["flutter.idToken", "flutter.testidToken"];

/**
 * Reads the user session persisted on this origin. Returns the parsed ID
 * token, or undefined when no readable, unexpired token exists.
 */
function readUserSession(): IDToken | undefined {
  for (const key of ID_TOKEN_STORAGE_KEYS) {
    try {
      const raw = window.localStorage.getItem(key);
      if (!raw) continue;
      // The token may be stored JSON-quoted.
      const token = raw.startsWith('"') ? (JSON.parse(raw) as string) : raw;
      const payload = token.split(".")[1];
      if (!payload) continue;
      const claims = decodeBase64UrlJson<IDToken>(payload);
      // Only a token with a numeric, future expiry counts as a session.
      if (typeof claims.exp !== "number" || claims.exp * 1000 <= Date.now()) {
        continue;
      }
      return claims;
    } catch {
      // Unreadable entry; keep scanning.
    }
  }
  return undefined;
}

export type { IDToken };
export { readUserSession };
